"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasComponentRenderer = void 0;
/**
 * @public
 * {@inheritDoc ICanvasComponentRenderer}
 */
class CanvasComponentRenderer {
    constructor(context, sharedState) {
        this.context = context;
        this.sharedState = sharedState;
        this.specification = {};
    }
    onAfterInitialization() {
        // no action needed
    }
    onBeforeInitialization() {
        // no action needed
    }
    onAfterDraw() {
        // no action needed
    }
    onBeforeDraw() {
        // no action needed
    }
    onContextLost() {
        // no action needed
    }
}
exports.CanvasComponentRenderer = CanvasComponentRenderer;
//# sourceMappingURL=canvas-component-renderer.js.map